import React, { useEffect, useRef, useState } from "react";
import {
    Container,
    Typography,
    Card,
    CardContent,
    TextField,
    Button,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Divider,
    Grid,
    IconButton,
    Box,
    CircularProgress,
} from "@mui/material";
// import axios from "axios";
import { Add, Edit, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
// import { useParams } from "react-router-dom";
import authService from "../Auth/AuthService";

export default function FeesStructurePage({ masterId }) {
    // const { schoolCode } = useParams();
    const [feesStructures, setFeesStructures] = useState([]);
    const [formData, setFormData] = useState({
        id: null,
        schoolId: masterId,
        annualFee: "",
        standard: "",
        branch: "",
    });
    const [isEditing, setIsEditing] = useState(false);
    const [openForm, setOpenForm] = useState(false);
    const hasFetched = useRef(false);
    const [isDisabled, setIsDisabled] = useState(false);

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;
        fetchFeesStructures();
    }, []);

    const fetchFeesStructures = async () => {
        try {
            const url = authService.pathUrl('GET', '/fees/structure')
            const response = await authService.getAuth(url);
            setFeesStructures(response);
        } catch (error) {
            console.error("Error fetching fees structures:", error);
        }
    };

    const sortedFeesStructures = [...feesStructures].sort((a, b) => {
        const aNum = parseInt(a.standard, 10);
        const bNum = parseInt(b.standard, 10);
        return aNum - bNum;
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        setIsDisabled(true);
        e.preventDefault();
        // setTimeout(() => setIsDisabled(false), 1000);
        try {
            const url = authService.pathUrl('PUTPOST', '/fees/structure')
            if (isEditing) {
                await authService.putAuth(`${url}/${formData.id}`, formData);
            } else {
                await authService.postAuth(url, formData);
            }
            fetchFeesStructures();
            resetForm();
            setIsDisabled(false);
        } catch (error) {
            console.error("Error saving fees structure:", error);
            setIsDisabled(false);
        }
    };

    const handleEdit = (structure) => {
        setFormData(structure);
        setIsEditing(true);
        setOpenForm(true)
    };

    const resetForm = () => {
        setFormData({
            id: null,
            schoolId: masterId.masterId,
            annualFee: "",
            standard: "",
            branch: '',
        });
        setIsEditing(false);
    };

    return (
        <Box p={3}>
            {/* <Container maxWidth="md" > */}
            <Box display="flex" justifyContent="space-between">
                <Typography variant="h4" gutterBottom fontWeight="bold" color="#1b1914">
                    Fees Structure Management
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Grid container spacing={2}>
                    <IconButton sx={{ border: "1px solid", borderRadius: "10px", my: 1 }}
                        color="grey"
                        onClick={() => setOpenForm(!openForm)}
                        title="Add"
                    >
                        {openForm ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                </Grid>
            </Box>
            {/* --- Form Card --- */}
            {openForm && (
                <Container maxWidth="md" >
                    <Card sx={{ mb: 4 }}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom color="#3f2d01" textAlign={'center'}>
                                {isEditing ? "Update Fees Structure" : "Add Fees Structure"}
                            </Typography>
                            <form onSubmit={handleSubmit}>
                                <TextField
                                    label="Standard 1st/2nd/3rd/4th.."
                                    name="standard"
                                    value={formData.standard}
                                    onChange={handleChange}
                                    fullWidth
                                    margin="normal"
                                    required
                                />
                                <TextField
                                    label="Annual Fee"
                                    name="annualFee"
                                    type="number"
                                    value={formData.annualFee}
                                    onChange={handleChange}
                                    fullWidth
                                    margin="normal"
                                    required
                                />
                                {parseInt(formData.standard) > 10 && (
                                    <TextField
                                        label="branch"
                                        name="branch"
                                        placeholder="Science/commerce/atrs"
                                        value={formData.branch}
                                        onChange={handleChange}
                                        fullWidth
                                        margin="normal"
                                        required
                                    />
                                )}
                                <Button type="submit" variant="contained" sx={{ mt: 2, bgcolor: '#3f2d01', borderRadius: 5, fontWeight: 'bold' }} disabled={isDisabled}>
                                    {isDisabled ? (<CircularProgress size={20} sx={{ color: '#fff' }} />)
                                        : (isEditing ? "Update" : "Add")}
                                </Button>
                                {isEditing && (
                                    <Button onClick={resetForm} variant="outlined" sx={{ mt: 2, ml: 2, bgcolor: '#3f2d01', borderRadius: 5, fontWeight: 'bold', color: '#fff' }} >
                                        Cancel
                                    </Button>
                                )}
                            </form>
                        </CardContent>
                    </Card>
                </Container>
            )}
            {/* --- Table --- */}
            <Card>
                <CardContent>
                    <Typography variant="h6" gutterBottom color="#3f2d01" textAlign={'center'}>
                        Existing Fees Structures
                    </Typography>
                    <Divider />
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>Created By</TableCell>
                                <TableCell>Standard</TableCell>
                                <TableCell>Annual Fee</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Array.isArray(sortedFeesStructures) && sortedFeesStructures
                                .map((structure) => (
                                    <TableRow key={structure.id}>
                                        <TableCell>{structure.id}</TableCell>
                                        <TableCell>{structure.createdBy}</TableCell>
                                        <TableCell>{structure.standard}</TableCell>
                                        <TableCell>{structure.annualFee}</TableCell>
                                        <TableCell>
                                            <IconButton
                                                onClick={() => handleEdit(structure)}
                                                title="Update"
                                            >
                                                <Edit sx={{ border: "2px solid", borderRadius: "10px" }} />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>
            {/* </Container> */}
        </Box>
    );
}
